export const RECORD_USERINFO = 'RECORD_USERINFO'
export const AUTO_USERINFO = 'AUTO_USERINFO'
export const OUT_LOGIN = 'OUT_LOGIN'
export const UNREAD = 'UNREAD'

export const CONFIG_INFO = 'CONFIG_INFO' // 网站基本信息
export const LEVELINFO = 'LEVELINFO'
export const UNREADCOUNT = 'UNREADCOUNT'
export const CONFIG_FOOT = 'CONFIG_FOOT'
export const NOTICELIST = 'NOTICELIST'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js